import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';

import { SortDirectionStoreModelEnum } from '@shared/enums/sort-direction.enum';
import { PopoverDirective } from '@shared/modules/popover/popover.directive';

import { appIconArrowDown12Icon } from '@icons/icon-arrow-down-12';
import { appIconArrowUp12Icon } from '@icons/icon-arrow-up-12';

@Component({
  selector: 'app-table-cell-sortable-header',
  imports: [SvgIconComponent, PopoverDirective],
  templateUrl: './table-cell-sortable-header.component.html',
  host: {
    class: 'flex items-center text-foreground-primary-60',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellSortableHeaderComponent {
  public title = input.required<string>();
  public titleTooltip = input<string>();
  public sortDirection = input<SortDirectionStoreModelEnum>();
  public sortClick = output<SortDirectionStoreModelEnum>();

  public readonly SortDirectionStoreModelEnum = SortDirectionStoreModelEnum;

  constructor() {
    injectRegisterIcons([appIconArrowUp12Icon, appIconArrowDown12Icon]);
  }

  public onSortClick(): void {
    const newSortDirection =
      this.sortDirection() === SortDirectionStoreModelEnum.Asc ? SortDirectionStoreModelEnum.Desc : SortDirectionStoreModelEnum.Asc;
    this.sortClick.emit(newSortDirection);
  }
}
